const Nteam = {
  company_id: 10308,
};
export default Nteam;
